import React, { Component } from 'react';
import '../../pdp/css/pdp-tab.less';
import { ErrorBoundary } from './error-boundary';

class Tab extends Component {

  static defaultProps = {
    lazyLoad: true
  }

  state = {
    loaded: false
  }

  static getDerivedStateFromProps(nextProps, state){
      return (nextProps.active && !state.loaded) ? { loaded: true } : null;
  }

  render() {
    let {active, lazyLoad, prefetch } = this.props;
    if(lazyLoad) {
      return (
        <ErrorBoundary>
          <div className={`pdp-tab${active ? ' active' :  ''}`}>
            {
              React.Children.map(this.props.children, child => {
                return this.state.loaded || prefetch ? React.cloneElement(child, { isActive: active }) : null
              })
            }
          </div>
        </ErrorBoundary>
      );
    }
    else {
      return (
        <ErrorBoundary>
          <div className={`pdp-tab${active ? ' active' :  ''}`}>
              {React.Children.map(this.props.children, child => React.cloneElement(child, { isActive: active }))}
          </div>
        </ErrorBoundary>
      );
    }

  }

}

export default Tab;
